import LocalizedStringsDefault, * as LocalizedStringsNS from 'react-localization';
import en from './languages/en.json';

const LocalizedStrings =
  (typeof LocalizedStringsDefault === 'function' && LocalizedStringsDefault) ||
  (typeof LocalizedStringsNS?.LocalizedStrings === 'function' && LocalizedStringsNS.LocalizedStrings) ||
  (typeof LocalizedStringsNS?.default?.default === 'function' && LocalizedStringsNS.default.default);

export const Translations = new LocalizedStrings({ en });
